<template>
  <div v-loading="isLoading">
    <el-table
      :data="costCentres"
      stripe
    >
      <el-table-column
        label="Name"
        prop="name"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        label="Description"
        prop="description"
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />

      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
        width="270px"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editCostCentre(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteCostCentre(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <CostCentreEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :cost-centre="costCentre"
      :account-id="accountId"
      @saved="loadTable"
    />
    <!-- Bulk Create Form -->
    <CostCentreBulkCreateForm
      v-if="isShowBulkForm"
      ref="bulkForm"
      :is-show.sync="isShowBulkForm"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import CostCentreEditForm from '@/components/Application/Manage/Account/CostCentreEditForm'
import CostCentreBulkCreateForm from '@/components/Application/Manage/Account/CostCentreBulkCreateForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    CostCentreEditForm,
    CostCentreBulkCreateForm
  },
  props: {
    filters: {
      type: Array,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      costCentre: null,
      costCentres: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false,
      isShowBulkForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_address')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_address')
    }
  },
  mounted () {
    this.actions = [
      [
        {
          hidden: this.$user.cannot(CREATE, 'account_address'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.costCentre = new this.$sdk.account_costcentre()
            this.isShowEditForm = true
          }
        },
        {
          hidden: this.$user.cannot(CREATE, 'account_address'),
          name: 'Import',
          icon: ['fal', 'file-import'],
          event: () => {
            this.isShowBulkForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.loadTable()
        }
      ]
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_costcentre.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:asc'
        builder.filters = this.filters
      })
        .then(res => {
          this.costCentres = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editCostCentre (index, row) {
      this.costCentre = row
      this.isShowEditForm = true
    },
    deleteCostCentre (index, row) {
      this.$confirm('Are you sure to delete this cost centre?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
